<div class="nav-item btn-group"
     [class.show]="menuDropdownTrigger.menuOpen"
     data-test="header-notifications-button">
  <button class="nav-link"
          #menuDropdownTrigger="matMenuTrigger"
          [matMenuTriggerFor]="notifyMenu"
          [ngClass]="{'has-notifications':checkUnreadNotifications()}"
          [matTooltip]="'label.Notifications' | translate"
          data-test="header-notifications-notifications-button">
    <span class="fas fa-bell fa-lg fa-fw"></span>
    @if (checkUnreadNotifications()) {
      <i class="notification-circle" [ngStyle]="notificationBellCss"></i>
    }
  </button>

  <mat-menu class="iris-dropdown-menu"
            data-test="header-notifications-menu"
            [backdropClass]="'header-notify-overlay'"
            #notifyMenu="matMenu">
    @if (!notifications.length) {
      <div
        class="empty-box p-4 my-4"
        data-test="header-no-new-notifications">
        <div class="py-2 text-disabled">
          <span class="fas fs-1 fa-bell-exclamation"></span>
        </div>
        <span class="text-medium">{{ 'label.notifications.NoNewNotifications' | translate }}</span>
      </div>
    }
    <ul class="list-group">
      @for (notification of notifications; track notification) {
        <li
          class="item notification-item"
          [attr.data-test]="'header-notifications-' + notification.subject">
          <div class="item-content flex-row flex-middle">
            <div class="left-side">
              <div class="content-header justify-content-between">
                <span class="badge bg-disabled"
                      [style.background-color]="notification.notificationPriority.color">
                  {{ 'label.New' | translate }}
                </span>
                <h3 class="title primary-dark-blue">{{ notification.subject }}</h3>
              </div>
              <div class="content-body pt-2 pb-1"
                   [innerHtml]="fixMessage(notification.message) | safeHtml">
              </div>
              <div class="text-secondary" [matTooltip]="notification.eventDate | irisTime">
                {{ notification.eventDate | irisDateAgo }}
              </div>
            </div>
            <div class="flex-col-0">
              <sk-button
                [appearance]="'icon'"
                class="action-item"
                [matTooltip]="'label.MarkAsRead' | translate"
                (click)="markAsRead($event, notification)"
                data-test="header-notifications-mark-as-read-button">
                <i class="icon fas fa-comment-alt-check text-accent"></i>
              </sk-button>
            </div>
            <div class="flex-col-0">
              <sk-button
                [appearance]="'icon'"
                class="action-item"
                [matTooltip]="'label.OpenDetails' | translate"
                (click)="openNotificationList(notification)"
                data-test="header-notifications-open-details-button">
                <i class="fas icon fa-arrow-square-right text-accent"></i>
              </sk-button>
            </div>
          </div>
        </li>
      }
    </ul>
    <div class="notifications-buttons">
      <sk-button
        class="show-all-notifications"
        [appearance]="'text'"
        [label]="'label.ShowAllNotifications' | translate"
        [color]="'primary'"
        (click)="openNotificationList()"
        data-test="header-notifications-show-all-notifications-button"></sk-button>
      <sk-button
        [appearance]="'outlined'"
        [color]="'primary'"
        [label]="'label.MarkAllAsRead' | translate"
        [hidden]="!checkUnreadNotifications()"
        (click)="markAllAsRead($event)"
        data-test="header-notifications-mark-all-as-read-button">
      </sk-button>
    </div>
  </mat-menu>
</div>
